import axios, { AxiosResponse } from "axios";
import FeedContentDTO from "../../dto/feed-content.dto.ts";
import { ArticleDetailDto } from "../../dto/article-detail.dto.ts";
import { FavoriteDto } from "../../dto/favorite.dto.ts";
import { ArticleDto } from "../../dto/article.dto.ts";

export function fetchArticleFeed(
  code: string,
  externalUserId: string
): Promise<AxiosResponse<FeedContentDTO[]>> {
  const payload = {
    code,
    externalUserId,
  };

  return axios.post("feed", payload);
}

export function fetchArticleDetails(
  articleId: string,
  clientCode: string,
  externalUserId: string
): Promise<AxiosResponse<ArticleDetailDto>> {
  const payload = {
    code: clientCode,
    id: articleId,
    externalUserId,
  };

  return axios.post("/article", payload);
}

export function favoriteArticle(
  articleId: string,
  externalUserId: string
): Promise<AxiosResponse<void>> {
  const payload = {
    id: articleId,
    externalUserId,
    isFavorite: 1,
  };

  return axios.post<void>("article/favorite", payload);
}

export function removeFavoriteArticle(
  articleId: string,
  externalUserId: string
): Promise<AxiosResponse<void>> {
  const payload = {
    id: articleId,
    externalUserId,
    isFavorite: 0,
  };

  return axios.post<void>("article/favorite", payload);
}

export function fetchFavoriteArticles(
  externalUserId: string
): Promise<AxiosResponse<FavoriteDto[]>> {
  const payload = {
    externalUserId,
  };

  return axios.post<FavoriteDto[]>("article/favorites", payload);
}

export function fetchPromotionArticles(
  clientCode: string
): Promise<AxiosResponse<ArticleDto[]>> {
  const payload = {
    code: clientCode,
  };

  return axios.post<ArticleDto[]>("/promotion-articles", payload);
}

export function downloadArticleAppointment(appointmentId) {
  const payload = {
    appointmentId,
  };

  return axios.post("/appointment/download", payload);
}
